import { z } from 'zod';
import { IsoDateSchema, IsoDateTimeSchema } from '../common/ids.js';
import { ShiftSeriesCreateRequestSchema } from './series.js';
/**
 * `POST /shift-series/preview` — a dry run of the same series definition
 * used at creation, minus the assignee slots (occurrence expansion doesn't
 * need to know who fills them).
 */
export const ShiftSeriesPreviewRequestSchema = ShiftSeriesCreateRequestSchema.omit({
    assignees: true,
});
export const ShiftOccurrencePreviewSchema = z.object({
    businessDate: IsoDateSchema,
    startsAt: IsoDateTimeSchema,
    endsAt: IsoDateTimeSchema,
});
/**
 * Capped at 500 occurrences (03-API-CONTRACT.md §5, Track B brief) with the
 * TRUE total reported separately — this is the main defence against a
 * mis-typed RRULE materializing thousands of rows.
 */
export const ShiftSeriesPreviewResponseSchema = z
    .object({
    occurrences: z.array(ShiftOccurrencePreviewSchema).max(500),
    total: z.int().min(0),
})
    .refine((v) => v.total >= v.occurrences.length, {
    error: 'total must be at least the number of occurrences returned',
    path: ['total'],
});
//# sourceMappingURL=preview.js.map